"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElementalOverloadAbilityHandler = exports.ElementalOverloadActorAbilityFactory = exports.ElementalOverloadAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/effects/core");
const Duration_1 = require("../../core/Duration");
const Damage_1 = require("../../core/Damage");
const enums_1 = require("../../core/enums");
const Random_1 = require("../../utils/Random");
class ElementalOverloadAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ElementalOverload;
        this.__typeName = "ElementalOverload";
    }
}
exports.ElementalOverloadAbilityArgs = ElementalOverloadAbilityArgs;
let ElementalOverloadActorAbilityFactory = class ElementalOverloadActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ElementalOverload", "OneEnemies", 5);
    }
};
ElementalOverloadActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ElementalOverload")
], ElementalOverloadActorAbilityFactory);
exports.ElementalOverloadActorAbilityFactory = ElementalOverloadActorAbilityFactory;
let ElementalOverloadAbilityHandler = class ElementalOverloadAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                container.applyBuff({
                    sequence,
                    creatorId: ability.invokerId,
                    targetId: ability.invokerId,
                    duration: Duration_1.Duration.EndOfTurn,
                    effect: new core_1.UnblockableEffectArgs(),
                    onApplied: sequence => {
                        const damageType = (0, Random_1.randomElement)([
                            enums_1.DamageType.Fire,
                            enums_1.DamageType.Frost,
                            enums_1.DamageType.Nature,
                            enums_1.DamageType.Sonic
                        ]);
                        const damageAmount = container.getPercentOfBaseHealth(selectedEnemy, 75);
                        container.applyExactDamage({
                            sequence,
                            attackerId: ability.invokerId,
                            targetId: selectedEnemy,
                            damage: new Damage_1.Damage(damageType, damageAmount)
                        });
                    }
                });
            }
        });
    }
};
ElementalOverloadAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ElementalOverload)
], ElementalOverloadAbilityHandler);
exports.ElementalOverloadAbilityHandler = ElementalOverloadAbilityHandler;
